import { AnimatePresence, motion } from 'motion/react'
import { Check, Info, TriangleAlert } from 'lucide-react'

export interface ToastItem {
  id: number
  message: string
  kind: 'ok' | 'error' | 'info'
}

export function Toasts({ items, onDismiss }: { items: ToastItem[]; onDismiss: (id: number) => void }) {
  return (
    <div className="toast-stack" aria-live="polite">
      <AnimatePresence initial={false}>
        {items.map((toast) => (
          <motion.div
            key={toast.id}
            className={`toast toast-${toast.kind}`}
            layout
            initial={{ opacity: 0, y: 10, scale: 0.98 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 6, scale: 0.98 }}
            transition={{ type: 'spring', stiffness: 420, damping: 34 }}
            onClick={() => onDismiss(toast.id)}
          >
            <span className="toast-icon">
              {toast.kind === 'ok' ? <Check size={13} /> : toast.kind === 'error' ? <TriangleAlert size={13} /> : <Info size={13} />}
            </span>
            <span>{toast.message}</span>
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  )
}
